import { IconArrowDown, IconArrowUp, IconPoint } from '@tabler/icons-react'
import Stat from '../../stories/Stat/Stat'
import { useRacesLadderStats } from '../../ladder/api'

interface RaceRankDisplayProps {
  competitionId: number
  teamId: number
}

export default function RaceRankDisplay({
  competitionId,
  teamId,
}: RaceRankDisplayProps) {
  const { data: raceLadder } = useRacesLadderStats({
    competition_id: competitionId,
    team_id: teamId,
  })

  const raceRank = raceLadder.items[0]

  if (!raceRank) {
    return null
  }

  const getRankChangeIcon = (change: number) => {
    if (change > 0) return IconArrowUp
    if (change < 0) return IconArrowDown
    return IconPoint
  }

  const getRankChangeColor = (change: number) => {
    if (change > 0) return 'green'
    if (change < 0) return 'red'
    return 'gray'
  }

  return (
    <Stat
      title="League Position"
      value={raceRank.rank}
      icon={getRankChangeIcon(raceRank.rank_change ?? 0)}
      iconColor={getRankChangeColor(raceRank.rank_change ?? 0)}
      isValueSub
      isTeamHeader
      background="white"
    />
  )
}
